import { Model } from '../abstract/model.abstract'
import { ProviderTypeEnum } from '../enums/provider-type.enum'
import { UserPermissionModel } from './user-permission.model'

export class UserModel extends Model {
  id: number
  email: string
  name?: string
  firstName?: string
  lastName?: string
  middleName?: string
  gender?: string
  userProfile?: {
    firstName?: string
    lastName?: string
    middleName?: string
    gender?: string
  }
  providerType?: ProviderTypeEnum
  providerId?: string
  provider?: any
  regionId?: string
  region?: any
  regions?: any[]
  createdAt: string
  updatedAt: string
  statusId: number
  roles: any
  permissions: UserPermissionModel[]

  get isActive(): boolean {
    return this.statusId === 1 // Active status
  }

  get role(): string {
    return this.roles.map((el: any) => el.role.name).join(',')
  }

  get providerTypeLabel(): string {
    if (!this.providerType) {
      return '-'
    }
    switch (this.providerType) {
      case ProviderTypeEnum.Government:
        return 'Державний'
      case ProviderTypeEnum.Commercial:
        return 'Комерційний'
      default:
        return this.providerType
    }
  }
}
